import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Spinner } from "../Spinner/index.js";
import { cn } from "../../utils/index.js";
import { loadingSpinnerVariants } from "./LoadingSpinner.variants.js";
import { useDebounce } from "use-debounce";
function LoadingSpinner({ className, ...props }) {
    const [show, setShow] = useDebounce(false, 500);
    const styles = loadingSpinnerVariants({
        ...props,
        show: props.loading || show
    });
    const classes = cn(styles.base(), className);
    const { headerSticky, scrollable } = props;
    const overlayBodyOnly = !scrollable || scrollable && headerSticky;
    const width = 'calc(var(--table-width) * 1px)';
    const height = overlayBodyOnly ? 'calc(var(--table-height) * 1px - var(--table-head-height) * 1px)' : 'calc(var(--table-height) * 1px)';
    const top = overlayBodyOnly ? 'calc(var(--table-head-height) * 1px)' : '0';
    useEffect(()=>{
        setShow(props.loading ?? false);
    }, [
        props.loading,
        setShow
    ]);
    return /*#__PURE__*/ jsx("div", {
        className: cn(classes),
        style: {
            height,
            width,
            top
        },
        children: /*#__PURE__*/ jsx("div", {
            className: cn(styles.wrapper()),
            style: {
                height,
                width
            },
            children: /*#__PURE__*/ jsx("div", {
                className: "m-auto flex justify-center",
                "data-testid": "loading-spinner",
                children: /*#__PURE__*/ jsx(Spinner, {
                    isLoading: props.loading ?? false
                })
            })
        })
    });
}
export { LoadingSpinner };
